import { Header5 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IAdvantageItemProps {
  title: string;
  imgUrl?: string;
  counter: number;
}

export function AdvantageItem({ title, imgUrl }: IAdvantageItemProps) {
  return (
    <div className={styles['container']} style={{ backgroundImage: `url(${imgUrl})` }}>
      <div className={styles['title']}>
        <Header5 as="h3" color="white_100">
          {title}
        </Header5>
      </div>
    </div>
  );
}
